// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KRUv","col":"styles_col__t_joZ"};